<template>
  <div class="flex-y-center flex-wrap gap-2 mt-4">
    <CButton
      v-for="(user, idx) of users"
      :key="idx"
      :text="user?.telegram_username"
      class="w-max rounded-xl"
      size="sm"
      variant="info"
    >
      <template #icon>
        <span
          @click="deleteTelegramUser(user?.id)"
          class="icon-close text-dark text-lg transition-300 hover:text-red select-none"
        />
      </template>
    </CButton>
  </div>
</template>

<script setup lang="ts">
import CButton from "@/components/Common/CButton.vue";

interface Props {
  users: {
    id: number;
    user: number;
    telegram_username: string;
    telegram_chat_id: string;
  }[];
}
defineProps<Props>();
const emit = defineEmits<{
  (e: "handleDeleteTelegramUser", value: number): void;
}>();
const deleteTelegramUser = (id: number) => {
  emit("handleDeleteTelegramUser", id);
};
</script>

<style scoped></style>
